import FormikInput from './FormikInput';

export default FormikInput;
